import { Component } from '@angular/core';
import { DictionaryService } from '@app/core/services/dictionary.service';
import { UserType } from '@app/core/utils';
import { UserRole } from '@app/models';
import { TimetablePeriod } from '@app/pcs/models';

@Component({
  selector: 'pcs-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['../base-menu-dropdown.scss','./main-menu.component.scss']
})
export class MainMenuComponent {
  readonly userType = UserType;
  webServicesTabUserRoles: UserRole[] = [
    UserRole.IntegrationPlatformUser,
    UserRole.Admin
  ];
  ttp: TimetablePeriod = this.dictionaryService.getDefaultTimetablePeriod();

  constructor(private readonly dictionaryService: DictionaryService) {
  }
}

